<style>
.page-item{
        cursor:pointer;
}
.skeleton-line {
  height: 14px;
  width: 100%;
  background: linear-gradient(
    90deg,
    #eeeeee 25%,
    #dddddd 37%,
    #eeeeee 63%
  );
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.text-muted i {
  color: #999;
}

</style>

<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3 class="card-title">Daftar Mutasi Masuk</h3>
            </div>  
        </div>
		
		<!-- TOOLBAR FILTER TAHUN (DI ATAS CARD) -->
		<div class="d-flex justify-content-between align-items-center mb-2">

		  <!-- KIRI -->
		  <div class="d-flex align-items-center">
			 <label class="mr-2 font-weight-bold mb-0">Tahun</label>
			  <select
				v-model="tahunMutasiMasuk"
				class="form-control form-control-sm"
				style="width:130px"
				@change="getResults(1)"
			  >
				<option value="">Pilih</option>
				<option v-for="t in listTahunMutasiMasuk" :key="t" :value="t">
				  {{ t }}
				</option>
			  </select>
			</div>
		</div>
		
        <div class="row">
          <div class="col-12">        
            <div class="card">
              <div class="card-header">
                Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Data
                <div class="card-tools">
                    <input type="text" v-model="searchTerm"  placeholder="Cari">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th role='button' v-on:click="sortRecords('id', 'barang_masuk')">ID</th>
                      <th role='button' v-on:click="sortRecords('id', 'barang_masuk')">Tanggal Mutasi</th>
                      <th role='button' v-on:click="sortRecords('id', 'barang_masuk')">Sumber Dana</th>
                      <th role='button' v-on:click="sortRecords('id', 'barang_masuk')">Pengirim</th>
                      <th role='button' v-on:click="sortRecords('id', 'barang_masuk')">Total (Rp)</th>
                      <th role='button' v-on:click="sortRecords('id', 'barang_masuk')">Status</th>
                      <th role='button' v-on:click="sortRecords('id', 'barang_masuk')">Keterangan</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
					<!-- SKELETON -->
					<template v-if="isLoadingTable">
						<tr v-for="n in 5" :key="'sk-'+n">
						  <td colspan="10">
							<div class="skeleton-line"></div>
						  </td>
						</tr>
					</template>

					<!-- BELUM PILIH TAHUN -->
					<tr v-else-if="!tahunMutasiMasuk">
						<td colspan="10" class="text-center text-muted py-4">
						  Silakan pilih tahun untuk menampilkan data
						</td>
					</tr>

					<!-- DATA KOSONG -->
					<tr v-else-if="isDataKosong">
						<td colspan="10" class="text-center text-muted py-4">
						  <i class="fa fa-info-circle mr-1"></i>
						  Belum ada transaksi mutasi masuk pada tahun
						  <strong>{{ tahunMutasiMasuk }}</strong>
						</td>
					</tr>
					
                     <tr v-for="barangmasuk in barangmasuks.data" :key="barangmasuk.id">

                      <td>{{barangmasuk.id}}</td>
                      <td class="text-capitalize">{{barangmasuk.tanggal_masuk}}</td>
                      <td>{{barangmasuk.nama_sumber_dana}}</td>
                      <td>{{barangmasuk.nama_unit_kerja}}</td>
                      <td style="text-align:right">{{returnRupiah(barangmasuk.total)}}</td>
                      <td v-if="barangmasuk.status_diterima == '0'">
                          <span class="btn btn-warning" style="padding:0px 5px;">Menunggu</span></td>
                      <td v-else-if="barangmasuk.status_diterima == '1'">
                          <span class="btn btn-success" style="padding:0px 5px;">Diterima pada {{barangmasuk.tanggal_diterima}}</span></td>
                       <td v-else-if="barangmasuk.status_diterima == '2'">
                           <span class="btn btn-danger" style="padding:0px 5px;">Ditolak</span>
                       </td>
                      <td>{{barangmasuk.keterangan_diterima}}</td>
                      <td>

                       <!-- <router-link :to='"/detail_mutasi_masuk?barang_masuk_id=" + barangmasuk.id'>
                                <i class="nav-icon fas fa-list-ul red"></i>
                            </router-link>-->
							
						<router-link :to="{path: '/detail_mutasi_masuk', query: {barang_masuk_id: barangmasuk.id, tahun: tahunMutasiMasuk}}">
									<i class="nav-icon fas fa-list-ul red"></i>
								</router-link>
								
                         <template v-if="barangmasuk.status_diterima != 1">
							|
							<a @click="editModal(barangmasuk)">
							  <i class="fa fa-edit blue"></i>
							</a>
						  </template>
                      </td>
                    </tr>

                     <tr>
                        <td colspan="6" style="font-weight:bold; text-align:center;">Grand Total</td>
                        <td style="font-weight:bold; text-align:right;">{{returnRupiah(grandtotal)}}</td>
                        <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="barangmasuks" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Barang Masuk</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Barang Masuk</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateBarangMasuk() : createBarangMasuk()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Tanggal Terima</label>
                            <datepicker v-model="form.tanggal_diterima" :disabledDates="disabledAkhir" :format="format"  name="tanggal_diterima" class="form-controlx" :class="{ 'is-invalid': form.errors.has('tanggal_diterima') }"></datepicker>
                            <has-error :form="form" field="tanggal_diterima"></has-error>
                        </div>

                        <div class="form-group">
                            <label>Status</label>
                            <select v-model="form.status_diterima" name="status_diterima" class="form-control" :class="{ 'is-invalid': form.errors.has('Status Diterima') }">
                             <option selected value="">Pilih salah satu</option>

                            <option v-for="status in statuss" :value="status.id">
                                {{ status.nama }}
                            </option>

                            </select>
                            <has-error :form="form" field="status_diterima"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Keterangan</label>
                            <textarea v-model="form.keterangan_diterima" name="keterangan_diterima"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('keterangan_diterima') }">
                                </textarea>
                            <has-error :form="form" field="keterangan_diterima"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

    export default {
        components: {
            Datepicker
        },
        data () {
            return {
                editmode: false,
                barangmasuks : {},
                statuss : {},
                grandtotal :0,
                format: 'yyyy-MM-dd',
                akhir:'',
                disabledAkhir: {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(),
                        to: new Date(2100, 11, 31)
                    }]
                },
                form: new Form({
                    id : '',      
                    tanggal_diterima: '',
                    status_diterima: '',
                    keterangan_diterima: '',
                    barang_keluar_id:''
                }),
				tahunMutasiMasuk: this.$route.query.tahun ? parseInt(this.$route.query.tahun) : new Date().getFullYear(),
				listTahunMutasiMasuk: [],
				isLoadingTable: false, // ⬅️ untuk skeleton
            }
        },
		
		computed: {				
			isDataKosong() {
				return (
				  !this.isLoadingTable &&
				  this.tahunMutasiMasuk &&
				  this.barangmasuks?.data &&
				  this.barangmasuks.data.length === 0
				)
			  }
		},
		
        methods: {
            /*returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split(','),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            },*/
			
			returnRupiah(val){
				if(val === null || val === '' || val === undefined)
					return '0,00';

				return Number(val).toLocaleString('id-ID',{
					minimumFractionDigits:2,
					maximumFractionDigits:2
				});
			},
			
			sortRecords (index, tableName) {				
				this.sortIndex = index
				  this.showTable = tableName

				  this.sortDirection =
					this.sortDirection === 'asc' ? 'desc' : 'asc'

				  this.page = 1
				  this.getResults(1)
            },    
            changePageRange(){				
				this.page = 1
				this.getResults(1)  
            },
			
            getResults(page = 1) {

                  //this.$Progress.start();
                  
                  /*axios.get('/api/mutasi_masuk?page=' + page).then(({ data }) => (this.barangmasuks = data.data.barang_masuk, this.statuss = data.data.status, this.grandtotal = data.data.grand_total));*/
				  
				  // ⛔ jangan load data kalau tahun belum dipilih
				  if (!this.tahunMutasiMasuk) {
					this.barangmasuks = { data: [], total: 0 }
					this.grandtotal = 0
					return
				  }

				  this.isLoadingTable = true
				  this.$Progress.start()

				  axios.get('/api/mutasi_masuk', {
					params: {
					  page: page,
					  tahun: this.tahunMutasiMasuk,
					  sortIndex: this.sortIndex,
					  sortDirection: this.sortDirection,
					  showPage: this.perPage,
					  showTable: this.showTable
					}
				  }).then(({ data }) => {
					this.barangmasuks = data.data.barang_masuk
					this.statuss  = data.data.status
					this.grandtotal  = data.data.grand_total
				  }).finally(() => {
					this.isLoadingTable = false
					this.$Progress.finish()
				  })

                  //this.$Progress.finish();
            },
            updateBarangMasuk(){
                this.$Progress.start();
                this.form.put('/api/mutasi_masuk/'+this.form.barang_keluar_id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadBarangMasuks();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },

            editModal(barang_masuk){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(barang_masuk);
            },

            loadBarangMasuks(){
           
                    axios.get("/api/mutasi_masuk").then(({ data }) => (this.barangmasuks = data.data.barang_masuk, this.statuss = data.data.status, this.grandtotal = data.data.grand_total));
            }

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            this.$Progress.start();
            //this.loadBarangMasuks();
			const now = new Date().getFullYear()
			for (let i = 0; i < 2; i++) {
				this.listTahunMutasiMasuk.push(now - i)
			}
			// ⬅️ langsung load data tahun berjalan
			this.getResults(1)
            this.$Progress.finish();

        },
		watch: {
			'$route.query.tahun'(val) {
				this.tahunMutasiMasuk = val
				  ? parseInt(val)
				  : new Date().getFullYear()
				
				this.page = 1
				this.getResults(1)
			  },  
            searchTerm: function() {
                this.loadBarangMasuks();
            }
        }
    }

    function returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split(','),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            }
</script>